export var BearerEnum;
(function (BearerEnum) {
    BearerEnum["ACCOUNT"] = "ACCOUNT";
    BearerEnum["SUBACCOUNT"] = "SUBACCOUNT";
})(BearerEnum || (BearerEnum = {}));
export class PaystackCharge {
}
//# sourceMappingURL=definitions.js.map